// 所有表单的完整字段定义
// 确保提交时所有字段都存在，未填写的字段默认为 ""

export const ALL_FORM_FIELDS = {
  // 个人信息 1
  personal_1: {
    "surnames": "",
    "given_name": "",
    "full_name": "",
    "has_other_name": false,
    "other_names": "",
    "has_telecode_name": false,
    "telecode_name": "",
    "sex": "",
    "marital_status": "",
    "date_and_place_of_birth": {
      "year": "",
      "month": "",
      "day": "",
      "country": "",
      "city": "",
      "state_or_province": ""
    }
  },

  // 个人信息 2
  personal_2: {
    "country": "",
    "has_other_nationalities": false,
    "other_nationalities": "",
    "has_permanent_resident": false,
    "permanent_resident_country": "",
    "national_identification_number": "",
    "national_id_not_applicable": false,
    "us_social_security_number": "",
    "ssn_not_applicable": true,
    "us_taxpayer_id": "",
    "itin_not_applicable": true
  },

  // 旅行信息
  travel: {
    "purpose": [{ main_type: '', sub_type: '' }],
    "has_specific_plan": false,
    "arrival_day": "",
    "arrival_month": "",
    "arrival_year": "",
    "arrival_flight": "",
    "arrival_city": "",
    "stay_duration": "",
    "stay_duration_unit": "",
    "departure_day": "",
    "departure_month": "",
    "departure_year": "",
    "departure_flight": "",
    "departure_city": "",
    "location": [],
    "finance": "",
    "surnames": "",
    "given_name": "",
    "telephone_number": "",
    "email": "",
    "relationship": "",
    "same_address": "",
    "payer_address": "",
    "payer_address2": "",
    "payer_city": "",
    "payer_province": "",
    "payer_country": "",
    "zipcode": "",
    "company_name": "",
    "us_street_address1": "",
    "us_street_address2": "",
    "us_city": "",
    "us_state": "",
    "us_zip_code": "",
    // F2家属签证主申请人信息
    "principal_applicant_surnames": "",
    "principal_applicant_given_name": ""
  },

  // 旅行伙伴信息
  travel_companions_info: {
    "has_travel_companions": false,
    "group_travel": false,
    "group_name": "",
    "person_info": []
  },

  // 美国旅行历史
  previous_US_travel_info: {
    "have_ever_been_in_us": false,
    "visit_info": [],
    "ever_hold_driver_license": false,
    "driver_license": [],
    "ever_been_issued_visa": false,
    "last_visa": {
      "issued_year": "",
      "issued_month": "",
      "issued_day": "",
      "visa_number": "",
      "same_type_visa": false,
      "same_country_visa": false,
      "ten_printed_visa": false,
      "visa_lost": false,
      "visa_cancelled": false,
      "visa_lost_year": "",
      "visa_lost_explanation": ""
    },
    "visa_denial": false,
    "visa_denial_reason": "",
    "has_petition": false,
    "petition_reason": "",
    "visa_refused": false,
    "visa_refused_reason": ""
  },

  // 地址电话
  address_phone: {
    "home_address": {
      "street_address": "",
      "street_address_2": "",
      "city": "",
      "state": "",
      "zip_code": "",
      "country": ""
    },
    "mailing_address_same": true,
    // 初始化为完整形状，避免后端读取可选键时报错
    "mailing_address": { "street_address": "", "street_address_2": "", "city": "", "state": "", "zip_code": "", "country": "" },
    "primary_phone": "",
    "secondary_phone": "",
    "work_phone": "",
    "other_phone_used": false,
    "other_phone": [],
    "email": "",
    "other_email_used": false,
    "other_email": [],
    "social_media": [{ "social_media": "", "social_media_identifier": "" }],
    // 与前端组件对齐：数组而非字符串
    "share_social_media": []
  },

  // F2签证SEVIS信息
  f2_sevis_info: {
    "sevis_id": "",
    "principal_sevis_id": ""
  },

  // 护照签证
  passport_visa: {
    "ppt_type": "",
    "ppt_explain": "",
    "ppt_number": "",
    "ppt_book_number": "",
    "ppt_issued_country": "",
    "ppt_issued_city": "",
    "ppt_issued_state": "",
    "ppt_issued_year": "",
    "ppt_issued_month": "",
    "ppt_issued_day": "",
    "has_ppt_expiration": false,
    "ppt_expired_year": "",
    "ppt_expired_month": "",
    "ppt_expired_day": "",
    "ppt_lost": false,
    "lost_ppt": []
  },

  // 美国联系人
  us_contact: {
    "contact_person_na": false,
    "contact_person": {
      "contact_surnames": "",
      "contact_given_name": ""
    },
    "contact_orgnization_na": true,
    "contact_organization": {
      "contact_organization_name": ""
    },
    "address_and_phone": {
      "address_ln1": "",
      "city": "",
      "state": "",
      "postal_code": "",
      "phone_number": "",
      "email_address": "",
      "email_address_na": false
    },
    "relationship": ""
  },

  // 家庭信息
  family_info: {
    // 婚姻状况（从personal_1传递过来）
    "marital_status": "",
    
    // 父亲信息
    "father_surnames": "",
    "father_given_name": "",
    "father_surnames_unk_ind": false, // 父亲姓氏未知标识
    "father_given_name_unk_ind": false, // 父亲名字未知标识
    "father_birth_date": {
      "day": "",
      "month": "",
      "year": ""
    },
    "father_dob_unk_ind": true,
    "father_live_in_us_ind": false,
    "if_father_in_us_status": "",
    
    // 母亲信息
    "mother_surnames": "",
    "mother_given_name": "",
    "mother_surnames_unk_ind": false, // 母亲姓氏未知标识
    "mother_given_name_unk_ind": false, // 母亲名字未知标识
    "mother_birth_date": {
      "day": "",
      "month": "",
      "year": ""
    },
    "mother_dob_unk_ind": true,
    "mother_live_in_us_ind": false,
    "if_mother_in_us_status": "",
    
    // 其他美国亲属
    "us_immed_relative_ind": false, // 是否有其他直系亲属在美国
    "us_other_relative_ind": false, // 在美国是否还有其他亲属
    
    // 配偶信息（根据婚姻状况动态显示：M, C, P）
    "spouse_surnames": "",
    "spouse_given_name": "",
    "spouse_birth_date": {
      "day": "",
      "month": "",
      "year": ""
    },
    "spouse_dob_unk_ind": false,
    "spouse_nationality": "",
    "spouse_pob_city": "",
    "spouse_pob_city_unk_ind": false,
    "spouse_pob_country": "",
    "spouse_address_type": "",
    "spouse_address": {
      "street_address": "",
      "street_address_2": "",
      "city": "",
      "state": "",
      "zip_code": "",
      "country": ""
    },
    "spouse_live_in_us_ind": false,
    "if_spouse_in_us_status": "",
    
    // 前配偶信息（离婚状况：D）
    "number_of_former_spouses": "",
    "former_spouses": [],
    
    // 已故配偶信息（丧偶状况：W）
    "deceased_spouse_surnames": "",
    "deceased_spouse_given_name": "",
    "deceased_spouse_birth_date": {
      "day": "",
      "month": "",
      "year": ""
    },
    "deceased_spouse_nationality": "",
    "deceased_spouse_pob_city": "",
    "deceased_spouse_pob_country": ""
  },

  // 工作教育 1
  work_education: {
    "primary_occupation": "",
    "primary_occupation_explain": "",
    "present_employer_or_school_name": "",
    "street_address": "",
    "street_address_2": "",
    "city": "",
    "state": "",
    "zip_code": "",
    "country": "",
    "phone_number": "",
    "has_income": true,
    "monthly_income": 0,
    "describe_duties": "",
    "start_date": ""
  },

  // 工作教育 2
  work_education2: {
    "previously_employed": false,
    "previous_employments": [],
    "other_education": false,
    "previous_educations": []
  },

  // 工作教育 3
  work_education3: {
    "languages": [{ language_name: "CHINESE" }],
    "clan_tribe_ind": false,
    "countries_visited_ind": false,
    "countries_visited": [],
    "organization_ind": false,
    "organizations": [],
    "specialized_skills_ind": false,
    "specialized_skills_explanation": "",
    "military_service_ind": false,
    "military_services": [],
    "taliban_ind": false,
    "taliban_explanation": "",
    "insurgent_org_ind": false,
    "insurgent_org_explanation": ""
  },

  // 补充信息 1
  part1: {
    "disease": {
      "value": false,
      "explanation": ""
    },
    "disorder": {
      "value": false,
      "explanation": ""
    },
    "druguser": {
      "value": false,
      "explanation": ""
    }
  },

  // 补充信息 2
  part2: {
    "arrested": {
      "value": false,
      "explanation": ""
    },
    "controlled_substances": {
      "value": false,
      "explanation": ""
    },
    "prostitution": {
      "value": false,
      "explanation": ""
    },
    "money_laundering": {
      "value": false,
      "explanation": ""
    },
    "human_trafficking": {
      "value": false,
      "explanation": ""
    },
    "assisted_severe_trafficking": {
      "value": false,
      "explanation": ""
    },
    "human_trafficking_related": {
      "value": false,
      "explanation": ""
    }
  },

  // 补充信息 3
  part3: {
    "illegal_activity": {
      "value": false,
      "explanation": ""
    },
    "terrorist_activity": {
      "value": false,
      "explanation": ""
    },
    "terrorist_support": {
      "value": false,
      "explanation": ""
    },
    "terrorist_org": {
      "value": false,
      "explanation": ""
    },
    "terrorist_rel": {
      "value": false,
      "explanation": ""
    },
    "genocide": {
      "value": false,
      "explanation": ""
    },
    "torture": {
      "value": false,
      "explanation": ""
    },
    "ex_violence": {
      "value": false,
      "explanation": ""
    },
    "child_soldier": {
      "value": false,
      "explanation": ""
    },
    "religious_freedom": {
      "value": false,
      "explanation": ""
    },
    "population_controls": {
      "value": false,
      "explanation": ""
    },
    "transplant": {
      "value": false,
      "explanation": ""
    }
  },

  // 补充信息 4
  part4: {
    "removal_hearing": {
      "value": false,
      "explanation": ""
    },
    "immigration_fraud": {
      "value": false,
      "explanation": ""
    },
    "fail_to_attend": {
      "value": false,
      "explanation": ""
    },
    "visa_violation": {
      "value": false,
      "explanation": ""
    },
    "deport": {
      "value": false,
      "explanation": ""
    }
  },

  // 补充信息 5
  part5: {
    "child_custody": {
      "value": false,
      "explanation": ""
    },
    "voting_violation": {
      "value": false,
      "explanation": ""
    },
    "renounce_exp": {
      "value": false,
      "explanation": ""
    },
    "att_wo_reimb": {
      "value": false,
      "explanation": ""
    }
  },

  // F1签证额外联系人信息
  f1_additional_contacts: {
    "additional_contacts": [
      {
        "surnames": "",
        "given_name": "",
        "street_address_line1": "",
        "street_address_line2": "",
        "city": "",
        "state_province": "",
        "state_province_na": false,
        "postal_code": "",
        "postal_code_na": false,
        "country": "",
        "telephone": "",
        "telephone_na": false,
        "email": "",
        "email_na": false
      },
      {
        "surnames": "",
        "given_name": "",
        "street_address_line1": "",
        "street_address_line2": "",
        "city": "",
        "state_province": "",
        "state_province_na": false,
        "postal_code": "",
        "postal_code_na": false,
        "country": "",
        "telephone": "",
        "telephone_na": false,
        "email": "",
        "email_na": false
      }
    ]
  },

  // F1签证学校信息
  f1_school_info: {
    "sevis_id": "",
    "school_name": "",
    "course_of_study": "",
    "school_street_address1": "",
    "school_street_address2": "",
    "school_city": "",
    "school_state": "",
    "school_zip_code": ""
  }
};

/**
 * 获取所有表单的完整字段列表
 * @returns {Object} 包含所有表单字段的对象
 */
export const getAllFormFields = () => {
  return ALL_FORM_FIELDS;
};

/**
 * 确保表单数据包含所有字段
 * @param {string} formId 表单ID
 * @param {Object} formData 表单数据
 * @returns {Object} 包含所有字段的表单数据
 */
export const ensureAllFields = (formId, formData = {}) => {
  const fieldTemplate = ALL_FORM_FIELDS[formId];
  if (!fieldTemplate) {
    return formData;
  }

  const result = {};

  // 遍历所有字段，确保每个字段都存在
  Object.keys(fieldTemplate).forEach(field => {
    // 如果表单数据中有这个字段，使用表单数据；否则使用模板中的默认值
    result[field] = formData.hasOwnProperty(field) ? formData[field] : fieldTemplate[field];
  });

  return result;
};

/**
 * 确保所有表单数据都包含完整字段
 * @param {Object} allFormData 所有表单数据
 * @returns {Object} 包含所有字段的所有表单数据
 */
export const ensureAllFormDataComplete = (allFormData = {}) => {
  const result = {};

  Object.keys(ALL_FORM_FIELDS).forEach(formId => {
    result[formId] = ensureAllFields(formId, allFormData[formId]);
  });

  return result;
};
